const BIDI_CONTROLS = /[‪-‮⁦-⁩]/g;
export function stripBidiControls(value) {
    return value.replace(BIDI_CONTROLS, '');
}
export function hasBidiControls(value) {
    return /[‪-‮⁦-⁩]/.test(value);
}
export function withoutBidiControls(value) {
    return typeof value === 'string' ? stripBidiControls(value) : value;
}
//# sourceMappingURL=text.js.map